import { readCookie } from "@/utils/cookies";

export function getMaskedId() {
  if (typeof window !== "object") {
    return null;
  }

  const hostname = window.location.hostname;
  const maskedId = readCookie("masked_id");

  const isLocal = hostname.includes("localhost") || hostname.includes("dev.nutrafol.com");

  /*
   * On local the fetch to Magento is cross-origin so the browser won't send session cookies.
   * The masked_id must be in the URL. Prefer the live cookie (set by addManyToCart in E2E
   * or by a prior add-to-cart) so each test run uses the correct cart; fall back to
   * NEXT_PUBLIC_MASKED_ID for manual local dev when no cookie is present.
   */
  if (isLocal) {
    return maskedId || process.env.NEXT_PUBLIC_MASKED_ID || null;
  }

  /*
   * E2E test mode on any staging environment: the cart was created server-side via the
   * Magento REST API (no browser PHP session established), so GET /nutrafol-carts/ returns
   * empty. Use the masked_id cookie set by addManyToCart to resolve the cart by ID directly,
   * bypassing CheckoutSession. The e2emode cookie is set by setCheckoutCookie() in all tests.
   */
  if (readCookie("e2emode") === "true" && maskedId) {
    return maskedId;
  }

  return null;
}
